import * as actionTypes from './actionTypes';
import { FreeExtrachargeModel } from '@app/src/views/StepOne/form/models/freeExtracharge';

interface State {
  data: FreeExtrachargeModel;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {
    name: '',
    priceIgv: null,
    alias: '',
    price: null,
    tariffId: null,
    tariffCode: '',
    publicationId: null,
    id: null
  },
  isFetching: false,
  error: false
}

export const freeExtracharge = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_FREE_EXTRACHARGE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_FREE_EXTRACHARGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_FREE_EXTRACHARGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
